<template>
  <router-link
    v-if="!options.disabled"
    :to="{ ...routerObject }"
    :class="computedClass"
  >
    {{ options.transform(value || options.value) }}
  </router-link>
</template>

<script>
export default {
  name: 'DataTableTextColumn',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    row: {
      type: Object,
      default() {
        return {}
      },
    },
    options: {
      type: Object,
      default() {
        return {
          shouldWrap: false,
          disabled: false,
          to: {},
          value: '',
          // eslint-disable-next-line no-unused-vars
          transform: (value, row) => value,
        }
      },
    },
  },
  computed: {
    defaultTransform() {
      return this.value
    },
    computedClass() {
      return {
        noWrap: !this.options.shouldWrap,
      }
    },
    routerObject() {
      const obj = Object.assign({}, this.options.to);
      obj.params = {};
      obj.params.parent = this.row;
      obj.params.id = this.row[this.options.field || 'ID'];
      return obj;
    }
  },
}
</script>
